// src/users.js
//
// CENTRALIZED MEMBER LIST
// ------------------------
// Each key = PIN used for login
// Each entry includes pin, memberNumber, name, and any role flags
// Future profile fields (allergies, vehicleTags, dietaryNotes, etc.) can be added per member.
//

const users = {
  "2009228": { pin: "2009228", memberNumber: "2009228", name: "System Test" },
  "3158": { pin: "3158", memberNumber: "14", name: "John & Melissa Abdo" },
  "552676": { pin: "552676", memberNumber: "10", name: "Martha Alford" },
  "4452": { pin: "4452", memberNumber: "11", name: "Andy & Marty Anderson" },
  "1442": { pin: "1442", memberNumber: "15", name: "Eric & Amy Anderson" },
  "4031": { pin: "4031", memberNumber: "13", name: "Evan & Traci Anderson" },
  "2004": { pin: "2004", memberNumber: "12", name: "Nancy Jane Ashby" },
  "0058": { pin: "0058", memberNumber: "20", name: "Bill Banker" },
  "2007": { pin: "2007", memberNumber: "23", name: "Bill & Suzanne Beckman" },
  "0218": { pin: "0218", memberNumber: "22", name: "Lee & Desiree Beckman" },
  "1985#": { pin: "1985#", memberNumber: "24", name: "Martin & Donna Beckman" },
  "1934": { pin: "1934", memberNumber: "25", name: "Tom & Shirley Beckman" },
  "1976": { pin: "1976", memberNumber: "26", name: "Will & Sally Beckman" },
  "1228": { pin: "1228", memberNumber: "28", name: "Charles & Pam Bradley" },
  "1229": { pin: "1229", memberNumber: "29", name: "Rusty & Shelli Bradley" },
  "061152": { pin: "061152", memberNumber: "30", name: "Steve & Patty Bradley" },
  "5762": { pin: "5762", memberNumber: "33", name: "Bob & Melinda Brewer" },
  "1127": { pin: "1127", memberNumber: "235", name: "Seth & Kristin Carr" },
  "3500": { pin: "3500", memberNumber: "35", name: "Spencer & Kate Cochran" },
  "4132": { pin: "4132", memberNumber: "201", name: "Emily & Tad Colburn" },
  "050847": { pin: "050847", memberNumber: "90", name: "Allie Compton" },
  "2791": { pin: "2791", memberNumber: "37", name: "Bart & Mindy Culver" },
  "2528": { pin: "2528", memberNumber: "40", name: "Candy Davis" },
  "2825": { pin: "2825", memberNumber: "42", name: "Hayden & Sarah Davis" },
  "7984": { pin: "7984", memberNumber: "43", name: "Joy & Jane Dearman" },
  "3970": { pin: "3970", memberNumber: "223", name: "Tom & Becka Wright" },
  "8811": { pin: "8811", memberNumber: "45", name: "John & Rachel DeWitt" },
  "9194": { pin: "9194", memberNumber: "31", name: "Rozlyn Dossman" },
  "3014": { pin: "3014", memberNumber: "50", name: "David & Kim Eddins" },
  "3124": { pin: "3124", memberNumber: "53", name: "Jim & Suzanne Edmondson" },
  "3164": { pin: "3164", memberNumber: "68", name: "Diana Gotwals" },
  "1710!": { pin: "1710!", memberNumber: "69", name: "Jim & Janet Gotwals" },
  "3334": { pin: "3334", memberNumber: "86", name: "Peyton & Christy Haralson" },
  "3444": { pin: "3444", memberNumber: "83", name: "Frank & Bonnie Henke" },
  "3474": { pin: "3474", memberNumber: "81", name: "Ben & Amber Hilfiger" },
  "3544": { pin: "3544", memberNumber: "87", name: "James & Mahogany Hilfiger" },
  "3614": { pin: "3614", memberNumber: "84", name: "Roger & Sally Hilfiger" },
  "3121": { pin: "3121", memberNumber: "85", name: "Carole Hill" },
  "4721": { pin: "4721", memberNumber: "236", name: "Miled & Leslie Jabor" },
  "1776": { pin: "1776", memberNumber: "92", name: "Mike & Michelle Jansen" },
  "1949": { pin: "1949", memberNumber: "93", name: "Linda Jarnagan" },
  "6363": { pin: "6363", memberNumber: "91", name: "Preston & Debbie Jones, Jr." },
  "4034": { pin: "4034", memberNumber: "102", name: "Andy & Traci Krider" },
  "1944": { pin: "1944", memberNumber: "120", name: "John Larson" },
  "2323": { pin: "2323", memberNumber: "123", name: "Grant & Kalan Lloyd" },
  "8595": { pin: "8595", memberNumber: "121", name: "Paul & Jean Long" },
  "8916": { pin: "8916", memberNumber: "150", name: "Richard & Martha Martin" },
  "1014": { pin: "1014", memberNumber: "41", name: "Sharon Millington" },
  "1220": { pin: "1220", memberNumber: "130", name: "Jason & Emily Moreau" },
  "1620": { pin: "1620", memberNumber: "162", name: "Nancy Peake" },
  "5844": { pin: "5844", memberNumber: "180", name: "Bo & Susan Rainey" },
  "8185": { pin: "8185", memberNumber: "190", name: "Rob & Tracey Saunders" },
  "4734": { pin: "4734", memberNumber: "191", name: "Sally Saunders" },
  "4804": { pin: "4804", memberNumber: "194", name: "Nolan & Sarah Schaffer" },
  "3767": { pin: "3767", memberNumber: "192", name: "Grayson & Melinda Schuering" },
  "4944": { pin: "4944", memberNumber: "193", name: "Scott & Meredith Selman" },
  "0525": { pin: "0525", memberNumber: "196", name: "Gary & Shelli Stidham" },
  "062153": { pin: "062153", memberNumber: "195", name: "Greg & Ann Stidham" },
  "6771": { pin: "6771", memberNumber: "197", name: "Mike & Glenna Stidham" },
  "1987": { pin: "1987", memberNumber: "199", name: "John & Kim Summar" },
  "5294": { pin: "5294", memberNumber: "202", name: "Ron Sutor" },
  "0616": { pin: "0616", memberNumber: "204", name: "Johan & Andra Terburgh" },
  "1245": { pin: "1245", memberNumber: "145", name: "Laura Martin" },
  "051416": { pin: "051416", memberNumber: "009", name: "Tad & Brie Alford" },
  "42479": { pin: "42479", memberNumber: "210", name: "Greg & Betty Vann" },
  "1989": { pin: "1989", memberNumber: "231", name: "Clay & Meredith Waddel" },
  "74426": { pin: "74426", memberNumber: "240", name: "Stacey & Keith Williams" },
  "3200": { pin: "3200", memberNumber: "32", name: "Katie & Dic Winniford" },

  // ===== Roles =====
  "8675": {
    pin: "8675",
    memberNumber: "777",
    name: "Chef Brian",
    isChef: true
  },

  "9001": {
    pin: "9001",
    memberNumber: "9001",
    name: "Kitchen Staff",
    isKitchen: true
  },

  "2820686": {
    pin: "2820686",
    memberNumber: "2820686",
    name: "Admin User",
    isAdmin: true
  },

  "1122334455": {
    pin: "1122334455",
    memberNumber: "1122334455",
    name: "Accounting",
    isAccountant: true,
   },

  // ===== Dining-Hall Menu Kiosk =====
  // Read-only PIN for the TV/tablet in the dining hall.
  // Only shows today's + tomorrow's menu. No access to member data, bookings,
  // ballots, or admin screens. Safe to leave running unattended.
  "MENU": {
    pin: "MENU",
    memberNumber: "KIOSK",
    name: "Dining Hall Kiosk",
    isKiosk: true,
  },
};



export default users;
